import { useQuery } from "@tanstack/react-query";
import { Button } from "antd";
import dayjs from "dayjs";
import { FiClock } from "react-icons/fi";
import { useSelector } from "react-redux";
import { CorrectSVG, InfoSVG } from "../../../assets/common/AdminSvg";
import { adminGetPricingPlans } from "../../../network/admin";
import Plan from "./Plan";
type Props = {
  modalPriceUpdate: boolean;
  setModalPriceUpdate: any;
  currentPlan: any;
};

const PricingPlanBody = ({
  modalPriceUpdate,
  setModalPriceUpdate,
  currentPlan,
}: Props) => {
  const { data, isLoading } = useQuery(["plans"], () => {
    return adminGetPricingPlans();
  });
  const currentUser = useSelector((s: any) => s?.user?.data);

  console.log(data?.data);
  console.log(currentPlan, "currentPlancurrentPlancurrentPlancurrentPlan");

  return !modalPriceUpdate ? (
    <>
      <div className="text-xl font-semibold ">Salon Pricing plan</div>
      <p className="text-[#75757E] text-sm">
        your balance according to your pricing plan.
      </p>
      <div className="flex flex-col items-center">
        <span className="my-4 mt-0">{InfoSVG}</span>
        <div className="flex flex-wrap items-center justify-center w-4/5 gap-2">
          {currentPlan?.subscription_plan?.plan?.features
            .slice(0, 5)
            .map((e: any) => {
              return (
                <span className="flex items-center gap-2 whitespace-nowrap">
                  <span>{e?.value}</span>
                  <span>{e?.name}</span>
                  <span className="flex items-center">{CorrectSVG}</span>
                </span>
              );
            })}
        </div>
      </div>
      <div className="rounded-lg flex items-center gap-1 bg-[#EEF0FF] p-3 text-sm">
        <span className="font-normal">Renew at :</span>
        <span className="font-semibold text-color-primary">
          {dayjs(data?.data?.started_at).format("YYYY-MM-DD")}
        </span>
        <FiClock className="ml-1 text-color-primary" />
      </div>
      <Button
        type="primary"
        onClick={() => setModalPriceUpdate(true)}
        className="w-full text-base font-normal"
      >
        Update pricing plan
      </Button>
    </>
  ) : (
    <div className="flex justify-center gap-5">
      {data?.data?.data?.map((e: any, index: any) => {
        const feats = e?.features?.filter(
          (feature: any) =>
            feature.key !== "commission_new_online_bookings" &&
            feature.key !== "commission_recurring_online_bookings"
        );

        // Filtering commission features
        const commissions = e?.features?.filter(
          (feature: any) =>
            feature?.key === "commission_new_online_bookings" ||
            feature?.key === "commission_recurring_online_bookings"
        );
        console.log(e);

        return (
          <Plan
            data={e}
            recommended={e.id === 2}
            features={feats}
            taxFeatures={commissions}
            currentPlan={currentPlan?.subscription_plan?.plan?.id}
          />
        );
      })}
    </div>
  );
};

export default PricingPlanBody;
